import 'css-chunksrc/client/scenes/constraintEdition/startStartForm/styles.scss';export default {
  "form": "_form_14ijn_1"
};